<template>
  <div>
    <v-card>
    <v-card-text>
        <v-card flat>
          <v-card-text>
              <v-container fluid>
                  <v-row align="center" justify="center">
                      <v-col cols="4" v-if="graficoEv.datasets[0].data.length > 0">
                          <v-card elevation="10">
                          <v-card-text>
                              <LineChart :chartdata="graficoEv" :options="chartoption"/>
                          </v-card-text>
                          </v-card>
                      </v-col>
                      <v-col cols="4" v-if="graficoObCo.datasets[0].data.length > 0">
                          <v-card elevation="10">
                          <BarChart :chartdata="graficoObCo" :options="chartoption"/>
                          </v-card>                      
                      </v-col>

                      <v-col cols="4" v-if="graficoStatus.datasets[0].data.length > 0">
                          <v-card elevation="10">
                          <RadarChart :chartdata="graficoStatus" :options="chartoption"/>
                          </v-card>    
                       </v-col>                      
                  </v-row>

              <v-toolbar color="primary" dark>
                  <v-toolbar-title aling="center">Mis Evaluaciones Actuales</v-toolbar-title>
              </v-toolbar>
            <br>
          <v-data-table :headers="headers" :items="mieval" :items-per-page="100" class="elevation-1"
            :search="search" hide-default-footer>
            <template v-slot:item.descripcion="{ item }">
              <a @click="evaluacionMia(item.id)">{{item.descripcion}}</a>
            </template>
          </v-data-table>
            <br>

              <v-toolbar color="primary" dark v-if="empleados.length > 0">
                  <v-toolbar-title aling="center">Mi Equipo</v-toolbar-title>
              </v-toolbar>

              <v-container fluid>
                  <v-row>
                      <v-col cols="4" v-for="(emp) in empleados" :key="emp.id">
                          <v-card elevation="10">
                          <v-card-title class="d-flex justify-center">
                            <v-avatar  size="100">
                              <img :src="emp.imagen_usuario" alt="Imagen del Colaborador">
                            </v-avatar>
                          </v-card-title>
                          <v-card-subtitle class="d-flex justify-center">
                            <p>{{emp.nombres}} {{emp.apellidos}}</p>
                          </v-card-subtitle>
                          
                            <span class="d-flex justify-center">
                            {{emp.correo}}
                            </span>
                          <v-card-text>
                            <div v-for="(eva) in emp.evcol" :key="eva.id">
                              <a @click="evaluacion(eva.idevaluacion,emp.id)" v-if="eva.paso>0 && eva.etapaname != 'Completado'">{{eva.evaluacion}} Etapa: {{eva.etapaname}}</a>
                            </div>
                            
                          </v-card-text>
                          </v-card>
                      </v-col>
                  </v-row>
              </v-container>


              </v-container>
          </v-card-text>
        </v-card>
    </v-card-text>
  </v-card>

  </div>
</template>
<script>
import axios from "axios";
import api from "../conf/ruta-base";
import LineChart from '../components/line-charts';
import BarChart from '../components/bar-charts';
import PieChart from '../components/pie-charts';
import DougChart from '../components/doug-charts';
import PolarChart from '../components/polar-charts';
import RadarChart from '../components/radar-charts';
import UserProfile from '../data';
import moment from "moment";
moment.locale('es');
export default {
  name: 'dash',
  //Importamos los componentes a usar
  components: { LineChart, BarChart, PieChart, DougChart, PolarChart, RadarChart },
  //Definimos los datos a trabajar
  data:()=>({
    apiPath: "empleado", user: UserProfile.getUserData(), slider:100, primero:50, segundo:50,
    dialog: false,
    graficoStatus:{
        labels: ['Liderazgo','Trabajo en Equipo','Trabajo Individual','Resolución de Problemas','Tolerancia a Frustración'],
        datasets: [{
            label: 'Categorias de Evaluación',
            backgroundColor: ['#f87979','#42A5F5','#D50000','#311B92','#4CAF50','#FFC107'],
            data: [2.3,2.3,2.3,2.3,2.3]
        }]
    },
    chartoption:{
        responsive: true, 
        maintainAspectRatio: true,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
    },
    graficoEv:{labels: ['EV 2017','EV 2018','EV 2019','EV 2020'],
      datasets:[{
        label: 'Evaluaciones en el Tiempo',
        backgroundColor: ['#f87979','#42A5F5','#D50000','#311B92','#4CAF50','#FFC107'],
        data: [2,2.2,1.6,3]
      }]
    },
    graficoObCo:{labels: ['Resiliencia','Trabajo Equipo','Empatia','Liderazgo','Coordinacón','Proy a Tiempo','Casos Resueltos','Proy Terminados'],
      datasets:[{
        label: 'Competencias / Objetivos por mejorar',
        backgroundColor: ['#f87979','#42A5F5','#D50000','#311B92','#4CAF50','#FFC107','#42A5F5','#D50000'],
        data: [2,3,2,3,1.3,3,2.7,2.5]
      }]
    },    
    empleados: [], evaluaciones: [], mieval: [], search: '',
    headers: [
      { text: "Descripcion", align: "start", sortable: true, value: "descripcion" },
      { text: "% Com", value: "bcompetencias" },
      { text: "% Obj", value: "bobjetivos" },
      { text: "Responsable Actual", value: "dmedioano" },
      { text: "Fecha Inicio", value: "fecinicio" },
      { text: "Fecha Fin", value: "fecfin" },
      { text: "Escala", value: "escala" },
      { text: "Etapa", value: "paso" },
      { text: "Operaciones", value: "actions", sortable: false } ],
  }),
  mounted() {
    //Consultamos los colaboradores que supervisamos
    axios.get(api.api + this.apiPath + '/supervisor/'+this.user.emp.id)
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          this.empleados.push(r.data[i]);
        }
      })
      .catch(error => {
        console.log(error);
      });
    //Consultamos todas las evaluaciones para tener el arreglo con el nombre
    axios.get(api.api + 'evaluacion/')
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          let evaluacion = {
            id: r.data[i].id,
            id: r.data[i].descripcion,
          }
          this.evaluaciones.push(r.data[i]);
        }
      })
      .catch(error => {
        console.log(error);
      });
    //Consultamos las evaluaciones en las cuales esta participando (Activas)
    axios
      .get(api.api + 'evaluacion/misevaluaciones')
      .then(r => {
          for (let i = 0; i < r.data.length; i++) {
            //if(r.data[i].etapa !== 'Completado'){
              let Val = Object.values(r.data[i].evacol)
              let Obj = Object.keys(r.data[i].evacol)
              let notaPon = 0
              for(let x = 0; x < Obj.length; x++){
                if(Obj[x].slice(0, 5)=='fecha'){
                  r.data[i].evacol['fec'+Obj[x].slice(5)]=this.fecCreate(Val[x]);
                }
              }
              r.data[i].evacol.dmedioano = r.data[i].turno.nombres + ' ' + r.data[i].turno.apellidos
              r.data[i].evacol.paso = r.data[i].paso
              r.data[i].evacol.dstatus = (r.data[i].evacol.status==0) ? 'Inactiva':'Activa';
              
              if(r.data[i].etapa != 'Completado'){
                this.mieval.unshift(r.data[i].evacol);
              }
              if(r.data[i].etapa=='Completado' && r.data[i].competencias.length>0){
                for(let y = 0; y < r.data[i].competencias.length; y++){
                  let cal = 0
                  let pro = 0
                  let pon = 0
                  if(r.data[i].competencias[y].calificacionmed_col > 0){
                    cal++
                    pro += r.data[i].competencias[y].calificacionmed_col
                  }
                  if(r.data[i].competencias[y].calificacionmed_sup > 0){
                    cal++
                    pro += r.data[i].competencias[y].calificacionmed_sup
                  }
                  if(r.data[i].competencias[y].calificacionfin_col > 0){
                    cal++
                    pro += r.data[i].competencias[y].calificacionfin_col
                  }
                  if(r.data[i].competencias[y].calificacionfin_sup > 0){
                    cal++
                    pro += r.data[i].competencias[y].calificacionfin_sup
                  }
                  pon = ((pro / cal) * r.data[i].competencias[y].peso) / 100
                  notaPon += (pon * r.data[i].evacol.bcompetencias) / 100

                  pro = (pro / cal).toFixed(2)
                  //this.graficoObCo.labels.push(`Comp: ${y+1}`)
                  
                  //Parche Temporal
                  //this.graficoObCo.labels.push(r.data[i].competencias[y].nombre)
                  //this.graficoObCo.datasets[0].data.push(pro)
                  
                  //this.graficoStatus.labels.push(`Comp: ${y+1}`)
                  
                  //Parche Temporal
                  //this.graficoStatus.labels.push(r.data[i].competencias[y].nombre)
                  //this.graficoStatus.datasets[0].data.push(r.data[i].competencias[y].peso)
                }
              }
              if(r.data[i].etapa=='Completado' && r.data[i].objetivos.length>0){
                for(let y = 0; y < r.data[i].objetivos.length; y++){
                  let cal = 0
                  let pro = 0
                  let pon = 0
                  if(r.data[i].objetivos[y].calificacionmed_col > 0){
                    cal++
                    pro += r.data[i].objetivos[y].calificacionmed_col
                  }
                  if(r.data[i].objetivos[y].calificacionmed_sup > 0){
                    cal++
                    pro += r.data[i].objetivos[y].calificacionmed_sup
                  }
                  if(r.data[i].objetivos[y].calificacionfin_col > 0){
                    cal++
                    pro += r.data[i].objetivos[y].calificacionfin_col
                  }
                  if(r.data[i].objetivos[y].calificacionfin_sup > 0){
                    cal++
                    pro += r.data[i].objetivos[y].calificacionfin_sup
                  }
                  pon = ((pro / cal) * r.data[i].objetivos[y].peso) / 100
                  notaPon += (pon * r.data[i].evacol.bobjetivos) / 100
                  pro = (pro / cal).toFixed(2)
                  //this.graficoObCo.labels.push(`Obj: ${y+1}`)
                  
                  //Parche Temporal
                  //this.graficoObCo.labels.push(r.data[i].objetivos[y].nombre)
                  //this.graficoObCo.datasets[0].data.push(pro)
                  
                  //this.graficoStatus.labels.push(`Obj: ${y+1}`)
                  
                  //Parche Temporal
                  //this.graficoStatus.labels.push(r.data[i].objetivos[y].nombre)
                  //this.graficoStatus.datasets[0].data.push(r.data[i].objetivos[y].peso)
                }
              }
              if(r.data[i].etapa=='Completado'){
                let grap = {
                  ev: r.data[i].evacol.descripcion,
                  nota: notaPon
                }
              //Parche temporal
              //this.graficoEv.labels.push(grap.ev)
              //this.graficoEv.datasets[0].data.push(grap.nota)
              }
            //}
          }
      })
      .catch(error => {
        console.log(error);
      });

  },
  computed: {
    elprimero(){
      this.segundo = this.slider - this.primero;
      return this.primero;
    },
    elsegundo(){
      this.primero = this.slider - this.segundo;
      return this.segundo;
    }
  },
  methods: {
    //Enviamos a la vista de evaluacion
    evaluacion(ev,emp){
      this.$router.push('/evaluacion/'+ev+'/'+emp);
    },
    //Formateamos la fecha a español
    fecCreate(fec){
      if(fec != '' & fec != '0000-00-00 00:00:00'){
        let date = moment(fec).format('L');
          return date;
      }else{
          return '';
      }
    },
    //Enviamos a la vista de evaluacion del user actual
    evaluacionMia(id){
      this.$router.push('/evaluacion/'+id);
    },
  },
}
</script>